import { useContext, useEffect } from "react";
import { B2C_BALANCE_ELIGIBILITY, BillToCompanyContext, useSessionStorage } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/js-utils";
import { PAYMENT_CODES } from "@swiggy-private/payment-types";
import { isSplitPayMethodMMT } from "@payment-client/helpers/SplitPay";
import { SplitPayData } from "@swiggy-private/payment-ui";
import { SplitPayMethodValues } from "@payment-client/interfaces/SplitPay";
import { useBillToCompanyDetails } from "./useBillToCompanyDetails";
import { SESSION_STORAGE_KEYS } from "@swiggy-private/core-ui";

const useBillToCompanySplitPay = () => {
    const { isSelected, setIsSelected } = useContext(BillToCompanyContext);
    const { billToCompanyData } = useBillToCompanyDetails();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setSplitPayMethods] = useSessionStorage(
        SESSION_STORAGE_KEYS.SPLITPAY_METHOD,
        SplitPayMethodValues.DEFAULT as string,
    );

    const handleSplitPayMethodSelection = (isSplitpaySelected: boolean, methodData: SplitPayData) => {
        if (isEmpty(methodData)) {
            return;
        }

        if (isSplitPayMethodMMT(methodData)) {
            setIsSelected(isSplitpaySelected);
        } else {
            setIsSelected(false);
        }
    };

    useEffect(() => {
        if (isSelected && billToCompanyData?.balanceEligibility === B2C_BALANCE_ELIGIBILITY.LOW_BALANCE) {
            // currently only MMT is supported for B2C split pay, we need payment code as well in future for other payment methods
            setSplitPayMethods(PAYMENT_CODES.MMT);
        }
    }, [isSelected, billToCompanyData?.balanceEligibility]);

    return {
        handleSplitPayMethodSelection,
    };
};

export default useBillToCompanySplitPay;
